// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image-lock-ratio[data-v-2663917c]{overflow:hidden}.image-lock-ratio__container[data-v-2663917c]{position:relative;width:100%;overflow:hidden;margin:0!important}.image-lock-ratio__content[data-v-2663917c]{position:absolute;-o-object-fit:contain;object-fit:contain;-o-object-position:center;object-position:center;height:100%;width:100%;top:50%;left:50%;transform:translate(-50%,-50%)}", ""]);
// Exports
module.exports = exports;
